export default __webpack_public_path__ + "static/media/25.ce90b951.gif";